export default __webpack_public_path__ + "static/media/footer.1c64c8ed.webp";